// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-list-section[data-v-7b9fad9e]{padding-top:55px;padding-bottom:20px}.title[data-v-7b9fad9e]{text-align:center;font-size:2rem;line-height:2.25rem;font-weight:700;margin-bottom:21px}@media(min-width:992px){.title[data-v-7b9fad9e]{font-size:2.5rem;line-height:2.75rem}}[data-v-7b9fad9e] .swiper-slide{padding:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
